import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type PracticeMode = 'relaxed' | 'word-perfect';
export type VoiceSelection = 'female' | 'male';

interface SettingsState {
    mode: PracticeMode;
    selectedVoice: VoiceSelection;
    removeStageDirections: boolean;
    hideMyLines: boolean;
    cueMode: boolean;
    micEnabled: boolean;
}

const initialState: SettingsState = {
    mode: 'relaxed',
    selectedVoice: 'female',
    removeStageDirections: true,
    hideMyLines: false,
    cueMode: false,
    micEnabled: true,
};

const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        setMode(state, action: PayloadAction<PracticeMode>) {
            state.mode = action.payload;
        },
        setVoice(state, action: PayloadAction<VoiceSelection>) {
            state.selectedVoice = action.payload;
        },
        toggleHideMyLines(state) {
            state.hideMyLines = !state.hideMyLines;
        },
        toggleCueMode(state) {
            state.cueMode = !state.cueMode;
        },
        toggleStageDirections(state) {
            state.removeStageDirections = !state.removeStageDirections;
        },
        toggleMic(state) {
            state.micEnabled = !state.micEnabled;
        },
    },
});

export const {
    setMode, setVoice,
    toggleHideMyLines, toggleCueMode, toggleStageDirections, toggleMic,
} = settingsSlice.actions;

export default settingsSlice.reducer;
